(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail-hero"]) return;
  try {
    
  if (!customElements.get('zj-product-gallery')) {
    customElements.define(
      'zj-product-gallery',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.mainImage = this.querySelector('[data-main-image]');
          this.productTitle = this.querySelector('.zj-product-detail-hero__title');
          this.thumbnailRail = this.querySelector('[data-thumbnail-rail]');
          this.thumbnailBody = this.querySelector('[data-thumbnail-body]');
          this.thumbnailViewport = this.querySelector('[data-thumbnail-viewport]');
          this.scrollUpButton = this.querySelector('[data-thumbnail-scroll="-1"]');
          this.scrollDownButton = this.querySelector('[data-thumbnail-scroll="1"]');
          this.scrollbar = this.querySelector('[data-thumbnail-scrollbar]');
          this.scrollbarTrack = this.querySelector('[data-thumbnail-scrollbar-track]');
          this.scrollbarThumb = this.querySelector('[data-thumbnail-scrollbar-thumb]');
          this.thumbnailImages = Array.from(this.querySelectorAll('.zj-product-detail-hero__thumbnail-image'));
          this.handleClick = this.handleClick.bind(this);
          this.handleMainImageLoad = this.handleMainImageLoad.bind(this);
          this.handleSectionLoad = this.handleSectionLoad.bind(this);
          this.scheduleLayoutUpdate = this.scheduleLayoutUpdate.bind(this);

          this.addEventListener('click', this.handleClick);
          this.mainImage?.addEventListener('load', this.handleMainImageLoad);
          this.thumbnailViewport?.addEventListener('scroll', this.scheduleLayoutUpdate, { passive: true });
          window.addEventListener('resize', this.scheduleLayoutUpdate);
          document.addEventListener('shopify:section:load', this.handleSectionLoad);
          document.fonts?.addEventListener('loadingdone', this.scheduleLayoutUpdate);
          this.thumbnailImages.forEach((image) => image.addEventListener('load', this.scheduleLayoutUpdate));

          if (this.mainImage?.complete) this.updateMainImageOrientation();
          document.fonts?.ready.then(() => {
            if (this.isConnected) this.scheduleLayoutUpdate();
          });
          this.scheduleLayoutUpdate();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.mainImage?.removeEventListener('load', this.handleMainImageLoad);
          this.thumbnailViewport?.removeEventListener('scroll', this.scheduleLayoutUpdate);
          window.removeEventListener('resize', this.scheduleLayoutUpdate);
          document.removeEventListener('shopify:section:load', this.handleSectionLoad);
          document.fonts?.removeEventListener('loadingdone', this.scheduleLayoutUpdate);
          this.thumbnailImages?.forEach((image) => image.removeEventListener('load', this.scheduleLayoutUpdate));
          if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
          this.initialized = false;
        }

        handleClick(event) {
          const scrollButton = event.target.closest('[data-thumbnail-scroll]');
          if (scrollButton && this.contains(scrollButton)) {
            this.scrollThumbnails(Number(scrollButton.dataset.thumbnailScroll));
            return;
          }

          const thumbnail = event.target.closest('[data-gallery-thumbnail]');
          if (!thumbnail || !this.contains(thumbnail)) return;

          if (!this.mainImage || !thumbnail.dataset.imageUrl) return;

          this.mainImage.classList.remove('is-landscape', 'is-portrait', 'is-square');
          this.mainImage.src = thumbnail.dataset.imageUrl;
          this.mainImage.removeAttribute('srcset');
          this.mainImage.removeAttribute('sizes');
          this.mainImage.alt = thumbnail.dataset.imageAlt || '';

          if (thumbnail.dataset.imageWidth) this.mainImage.width = Number(thumbnail.dataset.imageWidth);
          if (thumbnail.dataset.imageHeight) this.mainImage.height = Number(thumbnail.dataset.imageHeight);

          this.querySelectorAll('[data-gallery-thumbnail]').forEach((button) => {
            button.setAttribute('aria-pressed', String(button === thumbnail));
          });

          thumbnail.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'nearest',
          });

          requestAnimationFrame(() => {
            if (this.mainImage?.complete) this.updateMainImageOrientation();
            this.scheduleLayoutUpdate();
          });
        }

        handleMainImageLoad() {
          this.updateMainImageOrientation();
          this.scheduleLayoutUpdate();
        }

        handleSectionLoad(event) {
          if (event.target?.contains(this)) this.scheduleLayoutUpdate();
        }

        updateMainImageOrientation() {
          if (!this.mainImage?.naturalWidth || !this.mainImage?.naturalHeight) return;

          this.mainImage.classList.remove('is-landscape', 'is-portrait', 'is-square');
          if (this.mainImage.naturalWidth > this.mainImage.naturalHeight) {
            this.mainImage.classList.add('is-landscape');
          } else if (this.mainImage.naturalHeight > this.mainImage.naturalWidth) {
            this.mainImage.classList.add('is-portrait');
          } else {
            this.mainImage.classList.add('is-square');
          }
        }

        scheduleLayoutUpdate() {
          if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
          this.layoutFrame = requestAnimationFrame(() => {
            this.layoutFrame = null;
            this.fitProductTitle();
            this.updateScrollControls();
          });
        }

        fitProductTitle() {
          if (!this.productTitle) return;

          const maximumSize = window.matchMedia('(max-width: 749px)').matches ? 24 : 28;
          const minimumSize = 16;
          let currentSize = maximumSize;

          this.productTitle.style.fontSize = `${currentSize}px`;
          while (currentSize > minimumSize) {
            const lineHeight = Number.parseFloat(getComputedStyle(this.productTitle).lineHeight);
            const maximumHeight = lineHeight * 3;
            if (this.productTitle.getBoundingClientRect().height <= maximumHeight + 0.5) break;

            currentSize -= 1;
            this.productTitle.style.fontSize = `${currentSize}px`;
          }
          this.productTitle.dataset.fittedSize = String(currentSize);
        }

        scrollThumbnails(direction) {
          if (!this.thumbnailViewport || !direction) return;

          const thumbnail = this.thumbnailViewport.querySelector('[data-gallery-thumbnail]');
          const gap = Number.parseFloat(getComputedStyle(this.thumbnailViewport).rowGap) || 0;
          const distance = (thumbnail?.getBoundingClientRect().height || 0) + gap;
          this.thumbnailViewport.scrollBy({
            top: direction * distance,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        }

        updateScrollControls() {
          if (
            !this.thumbnailRail ||
            !this.thumbnailBody ||
            !this.thumbnailViewport ||
            !this.scrollUpButton ||
            !this.scrollDownButton ||
            !this.scrollbar ||
            !this.scrollbarTrack ||
            !this.scrollbarThumb
          ) {
            return;
          }

          const isDesktop = window.matchMedia('(min-width: 750px)').matches;
          const isOverflowing =
            isDesktop && this.thumbnailViewport.scrollHeight > this.thumbnailRail.clientHeight + 1;
          this.thumbnailRail.toggleAttribute('data-overflowing', isOverflowing);
          this.scrollUpButton.hidden = !isOverflowing;
          this.scrollDownButton.hidden = !isOverflowing;
          this.scrollbar.hidden = !isOverflowing;

          const maximumScroll = Math.max(0, this.thumbnailViewport.scrollHeight - this.thumbnailViewport.clientHeight);
          this.scrollUpButton.disabled = !isOverflowing || this.thumbnailViewport.scrollTop <= 1;
          this.scrollDownButton.disabled =
            !isOverflowing || this.thumbnailViewport.scrollTop >= maximumScroll - 1;

          if (!isOverflowing) {
            this.scrollbarThumb.style.removeProperty('height');
            this.scrollbarThumb.style.removeProperty('transform');
            return;
          }

          const trackHeight = this.scrollbarTrack.clientHeight;
          const visibleRatio = this.thumbnailViewport.clientHeight / this.thumbnailViewport.scrollHeight;
          const thumbHeight = Math.max(28, Math.min(trackHeight, trackHeight * visibleRatio));
          const maximumThumbOffset = Math.max(0, trackHeight - thumbHeight);
          const scrollProgress = maximumScroll > 0 ? this.thumbnailViewport.scrollTop / maximumScroll : 0;

          this.scrollbarThumb.style.height = `${thumbHeight}px`;
          this.scrollbarThumb.style.transform = `translateY(${maximumThumbOffset * scrollProgress}px)`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zj-about-quality-system"] && !Shopify.designMode) return;
  try {
    
  const initializeCertificateSlider = (slider) => {
    if (slider.dataset.sliderInitialized === 'true') {
      slider.dispatchEvent(new CustomEvent('zj:certificate-gallery:update'));
      return;
    }

    slider.dataset.sliderInitialized = 'true';
    const gallery = slider.closest('.zj-about-quality__gallery');
    const track = slider.querySelector('.zj-about-quality__gallery-track');
    let pagination = gallery?.querySelector('[data-certificate-pagination]');
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let scrollFrame;

    const updatePagination = () => {
      if (!gallery || !track) return;

      const cards = [...track.querySelectorAll('.zj-about-quality__certificate')];
      const certificateCount = cards.length;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const cardsPerPage = isMobile ? 3 : 4;
      const pageCount = Math.ceil(cards.length / cardsPerPage);
      const shouldEnableSlider = isMobile ? certificateCount > 3 : certificateCount > 4;

      gallery.toggleAttribute('data-certificate-gallery', certificateCount > 3);
      slider.toggleAttribute('data-certificate-slider', certificateCount > 3);
      slider.classList.toggle('zj-about-quality__gallery-viewport--scrollable', certificateCount > 4);
      slider.classList.toggle('zj-about-quality__gallery-viewport--mobile-scrollable', certificateCount === 4);

      if (certificateCount > 3 && !pagination) {
        pagination = document.createElement('div');
        pagination.className = 'zj-about-quality__gallery-pagination';
        pagination.dataset.certificatePagination = '';
        pagination.hidden = true;
        pagination.setAttribute('aria-hidden', 'true');
        gallery.append(pagination);
      } else if (certificateCount <= 3 && pagination) {
        pagination.remove();
        pagination = null;
      }

      const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
      const isScrollable = shouldEnableSlider && pageCount > 1 && maxScroll > 1;

      slider.tabIndex = isScrollable ? 0 : -1;
      if (!isScrollable || !pagination) {
        if (pagination) pagination.hidden = true;
        slider.scrollLeft = 0;
        return;
      }

      pagination.hidden = false;

      if (Number(pagination.dataset.pageCount) !== pageCount) {
        pagination.replaceChildren();
        pagination.dataset.pageCount = pageCount;
        for (let index = 0; index < pageCount; index += 1) {
          const dot = document.createElement('span');
          dot.className = 'zj-about-quality__gallery-page-dot';
          pagination.append(dot);
        }
      }

      const firstCard = cards[0];
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      const cardStep = (firstCard?.getBoundingClientRect().width || 0) + gap;
      const pageOffsets = Array.from(
        { length: pageCount },
        (_, index) => Math.min(index * cardsPerPage * cardStep, maxScroll)
      );
      const activePage = pageOffsets.reduce((nearestIndex, offset, index) => {
        const nearestDistance = Math.abs(slider.scrollLeft - pageOffsets[nearestIndex]);
        return Math.abs(slider.scrollLeft - offset) < nearestDistance ? index : nearestIndex;
      }, 0);

      pagination.querySelectorAll('.zj-about-quality__gallery-page-dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activePage);
      });
    };

    const schedulePaginationUpdate = () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(updatePagination);
    };

    const trackObserver = new MutationObserver(schedulePaginationUpdate);
    trackObserver.observe(track, { childList: true });

    slider.addEventListener('mousedown', (event) => {
      if (event.button !== 0) return;
      if (slider.scrollWidth <= slider.clientWidth + 1) return;
      isDragging = true;
      startX = event.clientX;
      startScrollLeft = slider.scrollLeft;
      slider.classList.add('is-dragging');
      event.preventDefault();
    });

    window.addEventListener('mousemove', (event) => {
      if (!isDragging) return;
      slider.scrollLeft = startScrollLeft - (event.clientX - startX);
    });

    const stopDragging = () => {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove('is-dragging');
    };

    window.addEventListener('mouseup', stopDragging);
    window.addEventListener('blur', stopDragging);
    window.addEventListener('resize', schedulePaginationUpdate);
    slider.addEventListener('scroll', schedulePaginationUpdate, { passive: true });
    slider.addEventListener('dragstart', (event) => event.preventDefault());
    slider.addEventListener('zj:certificate-gallery:update', schedulePaginationUpdate);
    updatePagination();
    schedulePaginationUpdate();
  };

  const initializeCertificateSliders = (root = document) => {
    const sliders = root.matches?.('.zj-about-quality__gallery-viewport')
      ? [root]
      : root.querySelectorAll('.zj-about-quality__gallery-viewport');
    sliders.forEach(initializeCertificateSlider);
  };

  const refreshCertificateSliderFromThemeEditor = (event) => {
    const section = event.target.closest?.('.zj-about-quality-wrapper') || event.target;
    initializeCertificateSliders(section);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCertificateSliders(), { once: true });
  } else {
    initializeCertificateSliders();
  }

  document.addEventListener('shopify:section:load', (event) => initializeCertificateSliders(event.target));
  document.addEventListener('shopify:block:select', refreshCertificateSliderFromThemeEditor);
  document.addEventListener('shopify:block:deselect', refreshCertificateSliderFromThemeEditor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zj-product-discovery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let titleTooltipId = 0;
    let hasPositionedPublicAnchor = false;

    class ZJProductDiscovery extends HTMLElement {
      connectedCallback() {
        if (this.dataset.discoveryReady === 'true') return;
        this.dataset.discoveryReady = 'true';

        this.searchInput = this.querySelector('[data-discovery-search]');
        this.sortSelect = this.querySelector('[data-discovery-sort]');
        this.filterButtons = [...this.querySelectorAll('[data-filter-kind]')];
        this.grid = this.querySelector('[data-product-grid]');
        this.active = this.querySelector('[data-active-filters]');
        this.chips = this.querySelector('[data-filter-chips]');
        this.emptyClearButton = this.querySelector('[data-empty-clear]');
        this.hasFeaturedCollection = this.dataset.hasFeaturedCollection === 'true';
        this.searchTimer = null;
        this.requestController = null;
        this.titleTooltip = document.createElement('div');
        this.titleTooltip.className = 'zj-discovery-title-tooltip';
        this.titleTooltip.id = `zj-discovery-title-tooltip-${++titleTooltipId}`;
        this.titleTooltip.setAttribute('role', 'tooltip');
        this.titleTooltip.hidden = true;
        document.body.append(this.titleTooltip);

        this.handleClick = this.handleClick.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePopState = this.handlePopState.bind(this);
        this.handlePointerOver = this.handlePointerOver.bind(this);
        this.handlePointerOut = this.handlePointerOut.bind(this);
        this.handleFocusIn = this.handleFocusIn.bind(this);
        this.handleFocusOut = this.handleFocusOut.bind(this);
        this.hideTitleTooltip = this.hideTitleTooltip.bind(this);

        this.addEventListener('click', this.handleClick);
        this.addEventListener('submit', this.handleSubmit);
        this.addEventListener('mouseover', this.handlePointerOver);
        this.addEventListener('mouseout', this.handlePointerOut);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('focusout', this.handleFocusOut);
        this.searchInput?.addEventListener('input', this.handleInput);
        this.sortSelect?.addEventListener('change', this.handleSort);
        window.addEventListener('popstate', this.handlePopState);
        window.addEventListener('resize', this.hideTitleTooltip);
        document.addEventListener('scroll', this.hideTitleTooltip, true);

        this.titleResizeObserver = new ResizeObserver(() => this.updateTitleOverflow());
        this.querySelectorAll('[data-product-title]').forEach((title) => {
          this.titleResizeObserver.observe(title);
        });

        this.normalizePublicState();
        this.renderChips();
        if (this.needsContextRefresh()) this.loadResults();
        else this.positionPublicAnchor();
        requestAnimationFrame(() => this.updateTitleOverflow());
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.updateTitleOverflow();
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('submit', this.handleSubmit);
        this.removeEventListener('mouseover', this.handlePointerOver);
        this.removeEventListener('mouseout', this.handlePointerOut);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        this.searchInput?.removeEventListener('input', this.handleInput);
        this.sortSelect?.removeEventListener('change', this.handleSort);
        window.removeEventListener('popstate', this.handlePopState);
        window.removeEventListener('resize', this.hideTitleTooltip);
        document.removeEventListener('scroll', this.hideTitleTooltip, true);
        this.titleResizeObserver?.disconnect();
        this.requestController?.abort();
        this.titleTooltip?.remove();
        window.clearTimeout(this.searchTimer);
        delete this.dataset.discoveryReady;
      }

      updateTitleOverflow() {
        this.querySelectorAll('[data-product-title]').forEach((title) => {
          const isTruncated = title.scrollHeight > title.clientHeight;
          title.dataset.titleTruncated = String(isTruncated);
          if (!isTruncated && this.activeTitle === title) this.hideTitleTooltip();
        });
      }

      showTitleTooltip(title) {
        const isTruncated = title.scrollHeight > title.clientHeight;
        title.dataset.titleTruncated = String(isTruncated);
        if (!isTruncated) return;

        this.activeTitle = title;
        this.titleTooltip.textContent = title.textContent.trim();
        this.titleTooltip.hidden = false;
        this.titleTooltip.style.visibility = 'hidden';
        this.titleTooltip.style.left = '0';
        this.titleTooltip.style.top = '0';

        const titleRect = title.getBoundingClientRect();
        const card = title.closest('.zj-discovery-card');
        const cardRect = card.getBoundingClientRect();
        const viewportInset = 8;
        const tooltipGap = 2;
        const adjacentCardInset = 4;
        const gridColumnGap = Number.parseFloat(window.getComputedStyle(this.grid).columnGap) || 0;
        const fixedTooltipWidth = Math.min(
          cardRect.width + 2 * Math.max(0, gridColumnGap - adjacentCardInset),
          window.innerWidth - 2 * viewportInset
        );

        this.titleTooltip.style.width = `${fixedTooltipWidth}px`;
        this.titleTooltip.style.maxWidth = `${fixedTooltipWidth}px`;
        const tooltipRect = this.titleTooltip.getBoundingClientRect();
        let top = titleRect.top - tooltipRect.height - tooltipGap;
        if (top < viewportInset) top = titleRect.bottom + tooltipGap;
        top = Math.min(top, window.innerHeight - tooltipRect.height - viewportInset);

        const centeredLeft = cardRect.left + (cardRect.width - tooltipRect.width) / 2;
        const left = Math.min(
          Math.max(viewportInset, centeredLeft),
          window.innerWidth - tooltipRect.width - viewportInset
        );

        this.titleTooltip.style.left = `${left}px`;
        this.titleTooltip.style.top = `${top}px`;
        this.titleTooltip.style.visibility = 'visible';
        title.closest('.zj-discovery-card__link')?.setAttribute('aria-describedby', this.titleTooltip.id);
      }

      hideTitleTooltip() {
        if (!this.activeTitle) return;
        const link = this.activeTitle.closest('.zj-discovery-card__link');
        if (link?.getAttribute('aria-describedby') === this.titleTooltip.id) {
          link.removeAttribute('aria-describedby');
        }
        this.titleTooltip.hidden = true;
        this.activeTitle = null;
      }

      handlePointerOver(event) {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        const title = event.target.closest('[data-product-title]');
        if (title && this.contains(title)) this.showTitleTooltip(title);
      }

      handlePointerOut(event) {
        const title = event.target.closest('[data-product-title]');
        if (!title || title.contains(event.relatedTarget)) return;
        this.hideTitleTooltip();
      }

      handleFocusIn(event) {
        const link = event.target.closest('.zj-discovery-card__link');
        const title = link?.querySelector('[data-product-title]');
        if (title) this.showTitleTooltip(title);
      }

      handleFocusOut(event) {
        const link = event.target.closest('.zj-discovery-card__link');
        if (!link || link.contains(event.relatedTarget)) return;
        this.hideTitleTooltip();
      }

      positionPublicAnchor() {
        if (
          hasPositionedPublicAnchor ||
          this.id !== 'product-discovery' ||
          window.location.hash !== '#product-discovery'
        ) {
          return;
        }

        hasPositionedPublicAnchor = true;
        this.scrollIntoView({ block: 'start', behavior: 'instant' });
      }

      publicParams() {
        return new URLSearchParams(window.location.search);
      }

      dosageFormButton(params = this.publicParams()) {
        const requestedType = params.get('type')?.trim().toLowerCase();
        if (!requestedType) return null;

        return this.filterButtons.find((button) => {
          if (button.dataset.filterKind !== 'format') return false;
          const handle = button.dataset.filterValue?.toLowerCase() || '';
          const singularHandle = handle.endsWith('ies')
            ? `${handle.slice(0, -3)}y`
            : handle.endsWith('s')
              ? handle.slice(0, -1)
              : handle;
          return requestedType === handle || requestedType === singularHandle;
        });
      }

      normalizePublicState() {
        const params = this.publicParams();
        const requestedSort = params.get('sort');
        const allowedSorts = new Set(['featured', 'best-selling']);
        const dosageFormButton = this.dosageFormButton(params);
        let shouldReplaceUrl = false;

        if (
          dosageFormButton &&
          (dosageFormButton.getAttribute('aria-disabled') === 'true' ||
            !dosageFormButton.dataset.nativeFilterParam ||
            !dosageFormButton.dataset.nativeFilterValue)
        ) {
          params.delete('type');
          shouldReplaceUrl = true;
        }

        if (
          params.get('q')?.trim() ||
          (requestedSort && !allowedSorts.has(requestedSort)) ||
          (requestedSort === 'featured' && !this.hasFeaturedCollection)
        ) {
          params.delete('sort');
          shouldReplaceUrl = true;
        }

        if (shouldReplaceUrl) this.updatePublicUrl(params, 'replace');
      }

      desiredSort(params = this.publicParams()) {
        if (params.get('q')?.trim()) return 'relevance';
        const requestedSort = params.get('sort');
        if (requestedSort === 'best-selling') return requestedSort;
        if (requestedSort === 'featured' && this.hasFeaturedCollection) return requestedSort;
        return 'newest';
      }

      needsContextRefresh() {
        const params = this.publicParams();
        const requestedContext = params.get('q')?.trim() ? 'search' : 'browse';
        if (this.dataset.renderContext !== requestedContext) return true;
        const dosageFormButton = this.dosageFormButton(params);
        if (dosageFormButton && dosageFormButton.getAttribute('aria-pressed') !== 'true') return true;
        return requestedContext === 'browse' && this.dataset.browseSort !== this.desiredSort(params);
      }

      buildRequestUrl() {
        const publicParams = this.publicParams();
        const query = publicParams.get('q')?.trim() || '';
        const sort = this.desiredSort(publicParams);
        const sourceUrl = query
          ? this.dataset.searchUrl
          : sort === 'featured'
            ? this.dataset.featuredCollectionUrl
            : this.dataset.mainCollectionUrl;
        const requestUrl = new URL(sourceUrl, window.location.origin);

        if (query) {
          requestUrl.searchParams.set('q', query);
          requestUrl.searchParams.set('type', 'product');
        } else {
          const collectionSort = sort === 'best-selling' ? 'best-selling' : sort === 'featured' ? 'manual' : 'created-descending';
          requestUrl.searchParams.set('sort_by', collectionSort);
        }

        publicParams.forEach((value, name) => {
          if (name.startsWith('filter.')) requestUrl.searchParams.append(name, value);
        });
        const dosageFormButton = this.dosageFormButton(publicParams);
        if (dosageFormButton) {
          const name = dosageFormButton.dataset.nativeFilterParam;
          const value = dosageFormButton.dataset.nativeFilterValue;
          if (name && value && !requestUrl.searchParams.getAll(name).includes(value)) {
            requestUrl.searchParams.append(name, value);
          }
        }
        if (publicParams.get('page')) requestUrl.searchParams.set('page', publicParams.get('page'));
        requestUrl.searchParams.set('section_id', this.dataset.sectionId);
        return requestUrl;
      }

      updatePublicUrl(params, mode = 'push') {
        const url = new URL(window.location.href);
        url.search = params.toString();
        window.history[mode === 'replace' ? 'replaceState' : 'pushState']({}, '', `${url.pathname}${url.search}${url.hash}`);
      }

      async loadResults({ focusSearch = false } = {}) {
        this.requestController?.abort();
        this.requestController = new AbortController();
        this.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(this.buildRequestUrl(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: this.requestController.signal,
          });
          if (!response.ok) throw new Error(`Product Discovery request failed: ${response.status}`);
          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const nextDiscovery = parsed.querySelector('zj-product-discovery');
          if (!nextDiscovery) throw new Error('Product Discovery section was not returned.');

          this.replaceWith(nextDiscovery);
          if (focusSearch) {
            const nextInput = nextDiscovery.querySelector('[data-discovery-search]');
            nextInput?.focus();
            nextInput?.setSelectionRange(nextInput.value.length, nextInput.value.length);
          }
        } catch (error) {
          if (error.name !== 'AbortError') console.error(error);
          this.removeAttribute('aria-busy');
        }
      }

      handleClick(event) {
        const filter = event.target.closest('[data-filter-kind]');
        if (filter && this.contains(filter)) {
          if (filter.getAttribute('aria-disabled') === 'true') return;
          const params = this.publicParams();
          const name = filter.dataset.nativeFilterParam;
          const value = filter.dataset.nativeFilterValue;
          const values = params.getAll(name);
          const dosageFormButton = this.dosageFormButton(params);
          const isActiveDosageType = dosageFormButton === filter && filter.getAttribute('aria-pressed') === 'true';
          if (filter.dataset.filterKind === 'format') params.delete('type');
          params.delete(name);
          values.filter((item) => item !== value).forEach((item) => params.append(name, item));
          if (!values.includes(value) && !isActiveDosageType) params.append(name, value);
          params.delete('page');
          this.updatePublicUrl(params);
          this.loadResults();
          return;
        }

        const chip = event.target.closest('[data-native-filter-param]');
        if (chip && this.contains(chip)) {
          const params = this.publicParams();
          const name = chip.dataset.nativeFilterParam;
          const value = chip.dataset.nativeFilterValue;
          const values = params.getAll(name);
          const dosageFormButton = this.dosageFormButton(params);
          if (dosageFormButton?.dataset.nativeFilterValue === value) params.delete('type');
          params.delete(name);
          values.filter((item) => item !== value).forEach((item) => params.append(name, item));
          params.delete('page');
          this.updatePublicUrl(params);
          this.loadResults();
          return;
        }

        const clear = event.target.closest('[data-clear-filters]');
        if (clear && this.contains(clear)) {
          const params = this.publicParams();
          [...params.keys()].forEach((name) => {
            if (name === 'q' || name === 'sort' || name === 'type' || name === 'page' || name.startsWith('filter.')) {
              params.delete(name);
            }
          });
          this.updatePublicUrl(params);
          this.loadResults();
          return;
        }

        const pageButton = event.target.closest('[data-pagination-page]');
        if (pageButton && this.contains(pageButton) && !pageButton.disabled) {
          const params = this.publicParams();
          const page = Number(pageButton.dataset.paginationPage);
          page > 1 ? params.set('page', String(page)) : params.delete('page');
          this.updatePublicUrl(params);
          this.loadResults();
        }
      }

      handleInput() {
        window.clearTimeout(this.searchTimer);
        this.searchTimer = window.setTimeout(() => {
          const params = this.publicParams();
          const query = this.searchInput.value.trim();
          query ? params.set('q', query) : params.delete('q');
          params.delete('sort');
          params.delete('page');
          this.updatePublicUrl(params, 'replace');
          this.loadResults({ focusSearch: true });
        }, 180);
      }

      handleSort() {
        const params = this.publicParams();
        this.sortSelect.value === 'newest'
          ? params.delete('sort')
          : params.set('sort', this.sortSelect.value);
        params.delete('page');
        this.updatePublicUrl(params);
        this.loadResults();
      }

      handlePopState() {
        this.loadResults();
      }

      renderChips() {
        this.chips.replaceChildren();

        this.filterButtons.forEach((button) => {
          if (button.getAttribute('aria-pressed') !== 'true') return;

          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'zj-product-discovery__chip';
          chip.dataset.nativeFilterParam = button.dataset.nativeFilterParam;
          chip.dataset.nativeFilterValue = button.dataset.nativeFilterValue;
          chip.textContent = button.textContent.trim();
          chip.setAttribute(
            'aria-label',
            this.dataset.removeTemplate.replace('__filter__', button.textContent.trim())
          );
          this.chips.append(chip);
        });

        const hasActiveFilters = Boolean(this.publicParams().get('q')?.trim()) || this.chips.children.length > 0;
        this.active.hidden = !hasActiveFilters;
        if (this.emptyClearButton) this.emptyClearButton.hidden = !hasActiveFilters;
      }

      handleSubmit(event) {
        const jump = event.target.closest('[data-pagination-jump]');
        if (!jump || !this.contains(jump)) return;
        event.preventDefault();
        const input = jump.querySelector('[data-pagination-input]');
        const page = Math.min(Math.max(Number(input.value) || 1, Number(input.min)), Number(input.max));
        const params = this.publicParams();
        page > 1 ? params.set('page', String(page)) : params.delete('page');
        this.updatePublicUrl(params);
        this.loadResults();
      }
    }

    if (!customElements.get('zj-product-discovery')) {
      customElements.define('zj-product-discovery', ZJProductDiscovery);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zj-product-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-zj-product-faq]').forEach((section) => {
    if (section.dataset.zjFaqBound === 'true') return;
    section.dataset.zjFaqBound = 'true';

    section.querySelectorAll('details').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      const updateExpandedState = () => {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      };

      updateExpandedState();
      details.addEventListener('toggle', updateExpandedState);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
